<template>
	<AlertCardWrapper :actionTitle="actionTitle" @action-button-click="actionButtonClick" :alert="alert" :titleArr="titleArr">
		<template #subtitle>
			<SubTitle :text="subtitle" />
		</template>
	</AlertCardWrapper>
</template>

<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
export default {
	name: 'RedirectToUrl',
	mixins: [AlertTypeBaseMixin],
	computed: {
		titleArr() {
			return [{ text: this.alert.metadata.title || 'Go to url' }];
		},
		subtitle() {
			return this.alert.metadata.subtitle;
		},
		actionTitle() {
			return this.alert.metadata.action_title || 'Go';
		},
	},
	methods: {
		actionButtonClick() {
			if (this.alert.metadata.redirect_url) {
				window.open(this.alert.metadata.redirect_url, '_blank');
			}
			this.markAlertAsCompleted();
		},
	},
};
</script>
<style lang="scss" scoped></style>
